import React, { Component } from 'react';
import { withRouter, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { selectHeader } from '../../../../actions/globalActions';
import { getPrimaryAccount } from '../../../../utils/sessionUtil';
import { recognitionMap } from '../RecommendGrant/utils';
import GrantAllocationAndSchedule from './Steps/GrantAllocationAndSchedule/GrantAllocationAndSchedule';
import EditAndReviewGrant from './Steps/EditAndReviewGrant/EditAndReviewGrant';
import CharitySelect from './Steps/CharitySelect/CharitySelect';
import ContactPurposeRecognition from './Steps/ContactPurposeRecognition/ContactPurposeRecognition';
import RecommendFlow from '../../../../CommonComponents/RecommendFlow/RecommendFlow';
import { RecommendGrantStep } from '../RecommendGrant/Component/InfoRectangle/InfoRectangle';
import {
  CharityChangeLink,
  TableLabel,
  UnderlyingContent,
} from '../RecommendGrant/style';
import { formatAmount, recordError } from '../../../../utils/commonUtil';
import Alert from '../RecommendGrant/Component/Alert/Alert';
import {
  ContentProvider,
  Types,
} from '../../../../CommonComponents/ContentMessages';
import { agreementFlowDerivedStates } from './Selectors/AgreementFlowSelectors';

export class GrantPurposeAndRecognition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stepConfig: this.stepConfig(),
    };
    this.allocations = {
      weightedAllocations: 'By weighted percentage',
      byDollars: 'By percentage or dollar amount',
      byPercentage: 'By specific percentage',
    };
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = (event) => {
    let body = document.body;
    let html = document.documentElement;
    let height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    let finalHeight = height - window.pageYOffset;
    if (document.querySelector('.ant-affix')) {
      if (finalHeight === 1100 || finalHeight < 1100) {
        document.querySelector('.ant-affix').style.position = 'absolute';
        document.querySelector('.ant-affix').style.removeProperty('top');
        document.querySelector('.ant-affix').style.bottom = '15px';
      } else {
        document.querySelector('.ant-affix').style.position = 'fixed';
        document.querySelector('.ant-affix').style.removeProperty('bottom');
        document.querySelector('.ant-affix').style.top = '18px';
      }
    }
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.handleScroll);
  }

  routeChange = () => {
    try {
      this.props.history.push('/grants/grant-agreement');
      window.scrollTo(0, 0);
    } catch (error) {
      recordError(error);
    }
  };

  redirectPage = () => {
    this.setState(
      {
        toBeExit: !this.state.toBeExit,
      },
      () => {
        this.props.selectHeader('ACCOUNT SUMMARY');
        this.props.history.push('/');
      }
    );
  };

  renderSubHeader = () => {
    const { history } = this.props;
    return (
      <>
        {history.location.pathname === '/grants/grant-agreement' && (
          <Alert
            type="Notice: "
            heading="field_notice_content"
            body="field_show_more_content"
            page="Grant Agreement"
            contentType={Types.PAGE_NOTICES}
          />
        )}
        <Route
          key="/grants/grant-agreement/charity-purpose"
          path="/grants/grant-agreement/charity-purpose"
          render={() =>
            this.props.selectedCharityName ? (
              <CharityChangeLink>
                <TableLabel as="span">{`You have selected ${this.props.selectedCharityName}. Not the charity you wanted? `}</TableLabel>
                <UnderlyingContent onClick={this.routeChange}>
                  Choose a different charity.
                </UnderlyingContent>
              </CharityChangeLink>
            ) : (
              ''
            )
          }
          exact
        />
      </>
    );
  };

  breadcrumbRoutes = () => {
    return [
      {
        routeName: 'Home',
        path: '/',
      },
      {
        routeName: 'Grants',
        path: '/grants',
      },
      {
        routeName: 'Grant Agreements',
        path: '/grants/agreement',
      },
    ];
  };

  onUpdate = () => {
    this.props.history.push('/grants/grant-agreement/review');
  };

  stepConfig = () => {
    const selectedAccountId =
      this.props.selectedAccountId || getPrimaryAccount().userId;
    return [
      {
        key: 1,
        route: '/grants/grant-agreement',
        description: 'Charity, purpose, and recognition',
        stepContent: () => {
          const {
            selectedCharityName,
            selectedCharityAddress = '',
            grantPurposeName,
            grantRecognitionId,
          } = this.props;
          const grantRecognitionName = recognitionMap[grantRecognitionId];
          const state = selectedCharityAddress.state;
          const city = selectedCharityAddress.city;
          return (
            <RecommendGrantStep prefixId="gawCharityPurpose" link="/grants/grant-agreement/charity-purpose">
              <div>
                <div>{selectedCharityName}</div>
                {/* <div>{state && city + ',' + state}</div> */}
                <div>
                  {grantPurposeName &&
                    'Purpose: ' + this.props.grantPurposeName}
                </div>
                <div>
                  {grantRecognitionName &&
                    'Recognition: ' + grantRecognitionName}
                </div>
              </div>
            </RecommendGrantStep>
          );
        },
        subRoutes: [
          {
            path: '/grants/grant-agreement/charity-purpose',
            component: () => (
              <ContactPurposeRecognition
                {...this.props}
                accountId={selectedAccountId}
                onUpdate={this.onUpdate}
                enableCancelPopUp
              />
            ),
          },
        ],
        mainContent: () => (
          <CharitySelect
            {...this.props}
            accountId={selectedAccountId}
            onUpdate={this.onUpdate}
          />
        ),
      },
      {
        key: 2,
        route: '/grants/grant-agreement/allocation-schedule',
        description: 'Grant allocation and schedule',
        stepContent: () => {
          const { grantAmount, allocationType, payment = [] } = this.props;
          const allocationDropDown = this.allocations[allocationType];
          const startDate = payment.length && payment[0].intendedPaymentDate;
          return (
            <RecommendGrantStep prefixId="gawAllocationSchedule" link="/grants/grant-agreement/allocation-schedule">
              <div>
                <div>{grantAmount && formatAmount(grantAmount)}</div>
                <div>{allocationDropDown ? allocationDropDown : null}</div>
                <div>{startDate && 'Starting ' + startDate}</div>
                <div>
                  {payment.length &&
                    `${payment.length} payments for a total of ${formatAmount(
                      grantAmount
                    )}`}
                </div>
              </div>
            </RecommendGrantStep>
          );
        },
        mainContent: () => (
          <GrantAllocationAndSchedule
            {...this.props}
            enableCancelPopUp
            accountId={selectedAccountId}
            onUpdate={this.onUpdate}
          />
        ),
      },
      {
        key: 3,
        route: '/grants/grant-agreement/review',
        description: 'Review grant and submit',
        mainContent: () => (
          <EditAndReviewGrant {...this.props} accountId={selectedAccountId} />
        ),
      },
    ];
  };

  render() {
    const {
      availableBalance,
      currentBalance,
      selectedAccountId,
      history,
    } = this.props;
    return (
      <ContentProvider
        types={[
          Types.PAGE_NOTICES,
          Types.PAGE_TITLE_DESCRIPTION,
          Types.PAGE_ALERTS,
          Types.PAGE_PLEASE_NOTE,
          Types.PAGE_PERMISSION_TO_PUBLISH,
        ]}
        pages={['Grant Agreement']}
      >
        <RecommendFlow
          userId={selectedAccountId}
          accData={{
            availableBalance,
            currentBalance,
          }}
          showCurrentBalance={false}
          snagSection={false}
          breadcrumbRoutes={this.breadcrumbRoutes()}
          pageHeader="Grant Agreement"
          stepConfig={this.state.stepConfig}
          beforeMainContent={this.renderSubHeader}
          history={history}
          featureCode="GA"
          grantAgreement
        />
      </ContentProvider>
    );
  }
}

GrantPurposeAndRecognition.propTypes = {
  selectedAccountId: PropTypes.string,
  availableBalance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currentBalance: PropTypes.number,
  selectedCharityName: PropTypes.string,
  selectedCharityAddress: PropTypes.string,
  selectedCharityEin: PropTypes.string,
  grantPurposeName: PropTypes.string,
  accountData: PropTypes.object,
  payment: PropTypes.array,
  grantAmount: PropTypes.string,
  allocationType: PropTypes.string,
  grantRecognitionId: PropTypes.string,
  edit: PropTypes.bool,
  selectHeader: PropTypes.func,
};
const mapStateToProps = (state) => ({
  ...agreementFlowDerivedStates(state.toJS()),
});

const mapDispatchToProps = (dispatch) => ({
  selectHeader: (metadata) => dispatch(selectHeader(metadata)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GrantPurposeAndRecognition)
);
